import Vue from 'vue';

/** Event bus for sending security events. */
const SecurityEventBus = new Vue();

export default SecurityEventBus;
